var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications",
    d: "M-0.00109863 17V15H1.9989V8C1.9989 6.61667 2.41557 5.3875 3.2489 4.3125C4.08223 3.2375 5.16557 2.53333 6.4989 2.2V1.5C6.4989 1.08333 6.64473 0.729167 6.9364 0.4375C7.22807 0.145833 7.58223 0 7.9989 0C8.41557 0 8.76973 0.145833 9.0614 0.4375C9.35307 0.729167 9.4989 1.08333 9.4989 1.5V2.2C10.8322 2.53333 11.9156 3.2375 12.7489 4.3125C13.5822 5.3875 13.9989 6.61667 13.9989 8V15H15.9989V17H-0.00109863ZM7.9989 20C7.4489 20 6.97807 19.8042 6.5864 19.4125C6.19473 19.0208 5.9989 18.55 5.9989 18H9.9989C9.9989 18.55 9.80307 19.0208 9.4114 19.4125C9.01974 19.8042 8.5489 20 7.9989 20ZM3.9989 15H11.9989V8C11.9989 6.9 11.6072 5.95833 10.8239 5.175C10.0406 4.39167 9.0989 4 7.9989 4C6.8989 4 5.95723 4.39167 5.1739 5.175C4.39057 5.95833 3.9989 6.9 3.9989 8V15Z",
    fill: "#4A4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.38e0dadd9b5a24e997039d2dcd8c3a64.svg";
export { ForwardRef as ReactComponent };